/// <amd-module name="Traceability/RunView/WorkItems/RunViewWorkItems" />
import React = require("react");
import { Utilities } from "Traceability/Common/Utilities";
import { RunViewCommonComponent } from "Traceability/RunView/Common/RunViewCommonComponent";
import { IRunViewCommonData, IRunViewCommonService } from "Traceability/RunView/Common/RunViewCommonService.types";
import * as Resources from "Traceability/RunView/WorkItems/Resources";
// Make sure IRunViewWorkItemsService is registered for FPS
import * as RunViewWorkItemsService from "Traceability/RunView/WorkItems/RunViewWorkItemsService";
import { IRunViewWorkItemsData, IRunViewWorkItemsService } from "Traceability/RunView/WorkItems/RunViewWorkItemsService.types";
import { IArtifactServerObject, IWorkItemsCardProps, WorkItemRef } from "Traceability/WorkItems/Types";
import { WorkItemsCard } from "Traceability/WorkItems/WorkItemsCard";
import { Components, IVssComponentContext } from "VSS/Platform/Layout";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

class RunViewWorkItems extends RunViewCommonComponent<WorkItemRef> {
    protected get pageTitleText(): string {
        return Resources.RunWorkItemsPageTitleText;
    }

    protected get pageHeaderText(): string {
        return Resources.WorkItemsPageHeaderText;
    }

    protected get service(): IRunViewCommonService<WorkItemRef> {
        return this._service as IRunViewCommonService<WorkItemRef>;
    }

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this._service = this.context.pageContext.getService<IRunViewWorkItemsService>("IRunViewWorkItemsService");
    }

    protected getCards(pageData: IRunViewCommonData<WorkItemRef>): JSX.Element[] {
        const workItemsPageData: IRunViewWorkItemsData = pageData as IRunViewWorkItemsData;
        const artifactsData = workItemsPageData && workItemsPageData.artifactsData || [];
        const hideCardTitle = artifactsData.length === 1;
        return artifactsData.map((artifactData: IArtifactServerObject<WorkItemRef>, index: number) => {
            const artifactDetails = Utilities.getArtifactDetailsObject<WorkItemRef>(artifactData, workItemsPageData.currentRunId);
            const cardProps: IWorkItemsCardProps<WorkItemRef> = {
                cardIndex: index,
                innerErrorMessage: artifactData.innerErrorMessage,
                artifactDetails: artifactDetails,
                data: artifactData.data || [],
                workItemTypes: this._service.getWorkItemTypes(artifactDetails),
                getPipelineTypeWorkItems: true,
                getCardData: this._service.getWorkItems,
                hideCardTitle: hideCardTitle
            };

            return <WorkItemsCard key={index} {...cardProps} />;
        });
    }

    private _service: IRunViewWorkItemsService;
}

Components.add("TraceabilityRunViewWorkItems", RunViewWorkItems);

